import { get, post } from '../util/zeusAxios.js'
import { formPost } from '../util/zeusFormAxios'
import { getBaseUrl, getEnv } from '../util/config'

// 登录
export const userLogin = parameters => formPost(`https://${getEnv()}apigateway.gaodun.com/api/v3/vigo/login`, parameters)

// 退出登录
export const userLogout = parameters => formPost(`https://${getEnv()}apigateway.gaodun.com/api/v1/vigo/logout`, parameters)

// 获取新的AccessToken
export const getAccessToken = (params) => formPost(`${getBaseUrl()}apigateway.gaodun.com/api/v1/token/refreshtoken`, params)

// 获取菜单权限
export const getCurrentUserMenuTree = parameters => get(`${getBaseUrl()}apigateway.gaodun.com/ep-backend/menu/list`, parameters)

// 根据token 获取用户信息
export const getUserInfoByToken = () => post(`https://${getEnv()}apigateway.gaodun.com/api/v1/token/checklogin`, {})



// WEBPACK FOOTER //
// ./src/js/api/login.js